<template>
	<div>
        <Loading :value="loading" ></Loading>
         <!-- MODAL AJOUTER UNE ZONES -->
    <v-dialog v-model="dialogZone" max-width="70%" persistent :overlay="true" scrollable>
      <v-card >
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span  v-if="(editForm == true && zoneDetail != null) || (editForm == false && zoneDetail == null) "  >Ajouter ou modifier une zone de maintenance </span>
            <span v-else-if="zoneDetail.label != undefined" >Ajouter une  sous zone à la zone {{zoneDetail.label}}  </span>
            <span v-else >Ajouter une  nouvelle zone   </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeDialog()" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
            <el-form id="formZone"  :model="formZone" :rules="rules" ref="formZone" class="demo-form-inline">
                <v-layout row >
                       <v-flex xs6 class="mr-1" >
                            <el-form-item label="Libellé" prop="libelle">
                                <el-input  v-model="formZone.libelle" name="libelle" placeholder="nom de zone"  style="width: 100%"></el-input>
                            </el-form-item>
                        </v-flex>

                        <v-flex xs6 class="" >
                          <el-form-item label="Entrepot" prop="entrepot">
                            <el-select  v-model="formZone.entrepot" name="entrepot" placeholder="Entrepot" style="width: 100%">
                                <el-option v-for="item in listeEntrepot" :key="item.id" :label="item.libelle" :value="item.id"></el-option>
                            </el-select>
                          </el-form-item>
                        </v-flex>
                </v-layout>

                 <v-layout row>
                    <v-flex xs12  >
                        <el-form-item label="Description" prop="description">
                            <el-input type="textarea" :row="6"   v-model="formZone.description" name="motif" placeholder="description de la zone"  style="width: 100%"></el-input>
                        </el-form-item>
                    </v-flex>
                </v-layout>

                <v-layout row class="text-xs-right">
                    <v-flex  xs12 >
                        <el-form-item  class="text-xs-right" >
                            <v-btn color="grey"  @click="resetForm('formZone')" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                            <v-btn v-if="editForm == false && zoneDetail.label == null" icons dark color="green" @click="submitForm('formZone')">Enregistrer<v-icon right>add</v-icon></v-btn>
                            <v-btn v-if="editForm == true && zoneDetail.label != null"  icons dark color="green" @click="submitForm('formZone')">Enregistrer les modifications<v-icon right>add</v-icon></v-btn>
                            <v-btn v-if="editForm == false && zoneDetail.label != null"  icons dark color="green" @click="submitForm('formZone')">Enregistrer une sous zone<v-icon right>add</v-icon></v-btn>
                        </el-form-item>
                    </v-flex>
                </v-layout>
            </el-form>

        </v-card-text>
      </v-card>
    </v-dialog>

	</div>
</template>


<script>
    import Loading from '@/components/Loading'
    export default {
	components:{ Loading },
        name: "AjoutZoneMaintenance",
        props:["show","zoneDetail","editForm"],
        data()
        {
         return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),

            loading: false,
            labelPosition: 'left',
            dialogZone: false,
            formZone: {},
            listeEntrepot:[],

                 rules: {
                libelle: [
                    { required: true, message: 'Veuillez saisir' },

                ],
                entrepot: [
                    { required: true, message: 'Veuillez selectionner' },

                ]

        }
         }
        },

        computed:{

        },
         watch: {
            show : function(newValue, oldvalue){
               this.dialogZone = newValue

               if(newValue == true)
               {
                   if(this.editForm == true){

                   this.formZone.libelle = this.zoneDetail.label
                   this.formZone.entrepot = this.zoneDetail.idEntr
                   this.formZone.description = this.zoneDetail.description
                   }
               }else {
                   this.formZone = {}
               }
            }
        },

        methods: {
        loadEntrepot ()
        {
            let url = this.domaine + 'entrepot/index'
            this.$http.get(url).then(response => {

                if (response.body) {
                    this.listeEntrepot = response.body.entrepot
                }
            })
        },
             createFilter(queryString) {
            return (link) => {
                return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
             closeDialog(){
                this.$emit('close')
            },
            submitForm(formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.loading = true
                 let form = document.getElementById("formZone")
                 //recuperation des demandes
                 let data = new FormData(form);
                 let url = "";
                 if( this.editForm == false && this.zoneDetail.label == null ) //creer une nouvelle zone
                 {
                    url = this.domaine + 'demande_maintenance/create/zone'
                 }
                 else if(this.editForm == false && this.zoneDetail.label != null) //ajouter une zone
                 {
                       url = this.domaine + 'demande_maintenance/create/souszone'
                       data.append("idZone",this.zoneDetail.id)
                 }
                 else  //modifier une sous une zone
                  {
                    url = this.domaine + 'demande_maintenance/edit/zone'
                     data.append("idZone",this.zoneDetail.id)
                 }



                 data.append("libelle",this.formZone.libelle)
                 data.append("idEntrepot",this.formZone.entrepot)
                 data.append("description",this.formZone.description)
                 data.append("userId",this.user.id)
                 this.$http.post(url, data).then(response => {
                     //reinitialiser le formulaire
                     this.resetForm('formZone')
                     this.formZone.description = ''
                     this.loading = false
                     this.successNotif("Zone enregistrée avec succès")
                     this.closeDialog()
                },
                (erreur) => {
                    //reinitialiser le formulaire
                     this.resetForm('formZone')
                      this.formZone.description = ''
                    this.closeDialog()
                     this.loading = false
                     this.$message.error("Une erreur est survenue lors de l'enregistrement de la zone")
                })
            }
            });
            },

        createFilter(queryString) {
            return (link) => {
                return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },

        successNotif(mess = ""){
            this.$notify({
                    title: 'ENREGISTREMENT REUSSI',
                    message: mess,
                    type: 'success',
                    position: 'top-center'
            })
        },

      },


        mounted(){
            this.loadEntrepot()
        }

    }
    </script>



// WEBPACK FOOTER //
// src/components/maintenance/AjoutZoneMaintenance.vue